(function () {
  if (window._cuakEtaInitialized) return;
  window._cuakEtaInitialized = true;

  var dayNames = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var monthNames = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function formatDate(d) {
    return dayNames[d.getDay()] + ' ' + d.getDate() + ' ' + monthNames[d.getMonth()];
  }

  // Suma dias HABILES: salta sabados y domingos.
  // La bodega no despacha fin de semana, asi que un pedido de viernes
  // arranca el lunes. Ver docs/negocio.md de dropi-agent.
  function addBusinessDays(from, days) {
    var d = new Date(from);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  function init(root) {
    var nodes = (root || document).querySelectorAll('[data-cuak-eta]:not([data-cuak-eta-ready])');
    nodes.forEach(function (el) {
      el.setAttribute('data-cuak-eta-ready', '1');
      var min = parseInt(el.getAttribute('data-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-max'), 10) || 5;
      var now = new Date();
      // Si el pedido entra sabado o domingo, el reloj arranca el lunes.
      var base = new Date(now);
      while (base.getDay() === 0 || base.getDay() === 6) {
        base.setDate(base.getDate() + 1);
      }
      var start = addBusinessDays(base, min);
      var end = addBusinessDays(base, max);
      var startEl = el.querySelector('[data-cuak-eta-start]');
      var endEl = el.querySelector('[data-cuak-eta-end]');
      if (startEl) startEl.textContent = formatDate(start);
      if (endEl) endEl.textContent = formatDate(end);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
